export const primaryRoleValidation = (arrOne, arrTwo ): boolean => {
    return arrOne.every(v => arrTwo.includes(v));
}
export const secondaryRoleValidation = (arrOne, arrTwo ): boolean => {
    return arrOne.some(r=> arrTwo.includes(r))
}